<template>
  <a-modal name="reviews-page-modal">
    <div class="reviews-link" @click.self="closeModal">
      <svg
        class="reviews-link-background"
        width="1597"
        height="431"
        viewBox="0 0 1597 431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="-3" width="1600" height="431" fill="#6367A7"/>
      </svg>
      <div class="reviews-page-modal">
        <span @click="closeModal" class="reviews-page-modal__close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="14.1426" width="20" height="2" transform="rotate(-45 0 14.1426)" fill="#68737D"/>
            <rect x="14.1484" y="15.5566" width="20" height="2" transform="rotate(-135 14.1484 15.5566)" fill="#68737D"/>
          </svg>
        </span>
        <form @submit.prevent="onSend">
          <template v-for="field in data.fields">
            <h2 v-if="field.type=='title'" class="reviews-page-modal__title">{{field.label}}</h2>
            <AInput
                v-else-if="field.type=='textarea'"
                :type="field.type"
                :label="field.label"
                :name="field.name"
                v-model="field.value"
            />
            <ABtn
                v-else-if="field.type=='btn'"
                :label="field.label"
                bg="#00A59E"
            />
          </template>
        </form>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {AModal, useAModal, AInput, ABtn, useAProgressBar} from '../../../ui';
import {ref} from "vue";
import {send} from "../../../../services/api";
import loginForm from "../../../forms/auth/LoginForm.vue";

export default {
  name: 'ReviewsPageModal',
  props: ['result'],
  components: {
    AModal,
    AInput,
    ABtn,
  },
  setup(props,ob) {
    const modal = useAModal();
    const progress = useAProgressBar();
    const closeModal = () => {
      modal.hide();
      if (location.hash) {
        let hash = window.location.hash.replace('#','');
        history.replaceState({}, '', window.location.href.replace('#'+hash,''));
      }
    }
    const onSend = async () => {
      progress.show();
      for (let index in data.value.fields) {
        data.value.ajax.data[data.value.fields[index].name] = data.value.fields[index].value;
      }

      await send(data.value.ajax.link, {method: "POST"}, data.value.ajax.data).then((response) => {
        if(response.success) {
          closeModal();
          showNotification('nativeSuccess','',response.text,
              {
                actions:[
                  {
                    bg:'#00A59E',
                    color:'',
                    title:response.okBtn,
                    action:false,
                    paternAction:'reload'
                  }
                ]
              });

        } else {
          showNotification('danger','',response.error);
        }
        progress.hide();
      })
    };
    const data = ref(props.result.form);

    return {
      closeModal,
      data,
      onSend,
    }
  },

}
</script>

<style lang="scss" scoped>
.reviews-link {
  min-height: 100vh;
  background-color: #fff;
}
.reviews-link-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.reviews-page-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__close{
    position: absolute;
    top: 22px;
    right: 17px;
    cursor: pointer;
  }
  :deep{
    .label{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #68737D;
    }
    .field{
      margin: 0 0 35px;
    }
    .a-btn{
      min-width: 270px;
    }
  }
}
</style>